import { Box } from "@mui/material";
import KsbActionButton from "../../../../2_ksbHub/components/KsbActionButton";

export default function BSZActions({ dialogs }) {
  return (
    <Box sx={{ mt: 1.5, display: "flex", justifyContent: "flex-end" }}>
      <KsbActionButton
        onClick={dialogs.openCreateRoom}
        label="Neuen Raum erstellen"
        variant="contained"
      />
    </Box>
  );
}
